import { inject, Injectable } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { Observable } from "rxjs";

import { TppServiceBeneficiaryDTO } from "@shared/models/tpp-service.interface";
import { TppApiServiceService } from "../api/tpp-api-service.service";
import { TppAccount } from "@shared/models/tpp-account.interface";
import { SelectOption } from "@shared/models/select-option.interface";

@Injectable({
	providedIn: "root"
})
export class TppCommonServiceService {
	private tppApiService = inject(TppApiServiceService);

	saveNewBeneficiary(
		formData: { account_name: string; country: SelectOption; currency: string },
		fields: Record<string, AbstractControl>,
		serviceId: string,
		skipValidation = false
	): Observable<TppServiceBeneficiaryDTO> {
		const rawFormData = formData;

		const data: TppServiceBeneficiaryDTO = {
			service: serviceId,
			country: rawFormData.country.value,
			name: rawFormData.account_name,
			currency: rawFormData.currency,
			bankAccount: {
				bankName: fields.bankName.value,
				country: rawFormData.country.value,
				currency: rawFormData.currency,
				fields: [],
				skipValidation
			}
		};

		data.bankAccount.fields = this.setBackAccountFileds(fields);

		return this.tppApiService.createTPPAccount(data);
	}

	updateNewBeneficairy(
		rawFormData: { account_name: string; country: SelectOption; currency: string },
		fields: Record<string, AbstractControl>,
		accountBeneficiary: TppAccount,
		skipValidation = false
	): Observable<TppServiceBeneficiaryDTO> {
		const data: TppServiceBeneficiaryDTO = {
			id: accountBeneficiary.id,
			version: accountBeneficiary.version ? accountBeneficiary.version : "",
			name: rawFormData.account_name,
			currency: rawFormData.currency,
			service: accountBeneficiary.service,
			country: rawFormData.country.value,
			bankAccount: {
				id: accountBeneficiary.bankAccount.id,
				version: accountBeneficiary.bankAccount.version ? accountBeneficiary.bankAccount.version : "",
				bankName: fields.bankName.value,
				country: rawFormData.country.value,
				currency: rawFormData.currency,
				fields: [],
				skipValidation
			}
		};

		data.bankAccount.fields = this.setBackAccountFileds(fields);

		return this.tppApiService.updateTPPAccount(data);
	}

	setBackAccountFileds(fields: Record<string, AbstractControl>): { key: string; value: string }[] {
		const fieldsArray: { key: string; value: string }[] = [];
		Object.keys(fields).forEach(field => {
			if (
				field !== "bankName" &&
				field !== "account_name" &&
				field !== "country" &&
				field !== "currency" &&
				field !== "client_id" &&
				fields[field].value !== null &&
				fields[field].value !== undefined &&
				fields[field].value !== ""
			) {
				fieldsArray.push({
					key: field,
					value: fields[field].value
				});
			}
		});

		return fieldsArray;
	}
}
